import { LinearGradient } from 'expo-linear-gradient';
import { lazy, memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { BackIcon } from '../../appComponents/BackIcon';
import { useUserInterfaceStyle } from '../../appComponents/UserInterfaceIdiomContext';
import { Colors } from '../../components/styles/Colors';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const HeaderBg = memo(() => {
  const userInterfaceStyle = useUserInterfaceStyle();
  if (userInterfaceStyle === 'dark') {
    return (
      <View
        style={StyleSheet.absoluteFill}
        css={`
          background-color: #000;
        `}
      />
    );
  }
  return (
    <LinearGradient
      colors={[Colors.Lime, 'white']}
      style={StyleSheet.absoluteFill}
    />
  );
});

const SearchPageContent = lazy(() => import('./SearchPageContent'));

export const SearchPage = wrapLazyNavigatorScreen(
  SearchPageContent,
  {
    title: 'Search',
    headerShown: false,
    headerBackImage: () => <BackIcon />,
    headerBackground: () => <HeaderBg />,
  },
  {
    title:
      'Search your favorite creators, shop their favorite fashion, toys and collectibles',
    description:
      'Want to shop what your favorite creator is wearing or using, browse millions of items from thousands of creators. Swipe-up, discover, have fun while shopping and connecting.',
  },
);
